/* eslint-disable no-extra-parens */
import {
    ChatAltIcon,
    CogIcon,
    HeroBeakerIcon,
    HeroCalendarDaysIcon,
    HeroEllipsisVerticalIcon,
} from 'components/Icon'

import {
    Dropdown, DropdownButtonNew, DropdownContent,
} from 'components/Dropdown'

import {
    dropdownsButtonsWrapper, list,
} from './../styles'

import Button from 'components/Button'
import {Icon} from 'components/Icon/types'
import React from 'react'
import Tooltip from 'components/Tooltip'

import {navigation} from 'navigation'
import {styled} from 'stitches/config'

import {
    useAppSelector,
} from 'hooks'
import {useTranslation} from 'react-i18next'

const StyledList = styled('ul', list)
const StyledDropdownButtonsWrapper = styled('div', dropdownsButtonsWrapper)

export const SideMenuQueueSettingsView = (): React.ReactElement => {
    const {t} = useTranslation()

    const {queue_id} = useAppSelector(({navigation: navigationState}) => navigation.route.params<'QueueSettings'>(navigationState.routes[navigationState.position]))

    return (
        <StyledList>
            <li>
                <Dropdown>
                    <DropdownButtonNew caret={false} color='text' iconRight={HeroEllipsisVerticalIcon as unknown as Icon} />
                    <DropdownContent direction='left' >
                        <StyledDropdownButtonsWrapper>
                            <Button color='text' iconLeft={CogIcon} onPress={(): void => { navigation.push('QueueSettings', {queue_id}) }} text={t('Settings')} />
                            <Button
                                color='text'
                                iconLeft={HeroCalendarDaysIcon as unknown as Icon}
                                onPress={(): void => {
                                    navigation.push('QueueSettings', {
                                        queue_id,
                                        tab: 'schedule',
                                    })
                                }}
                                text={t('Schedule')}
                            />
                            <Button
                                color='text'
                                iconLeft={HeroBeakerIcon as unknown as Icon}
                                onPress={(): void => {
                                    navigation.push('QueueSettings', {
                                        queue_id,
                                        tab: 'advanced',
                                    })
                                }}
                                text={t('Advanced settings')}
                            />
                            <Button
                                color='text'
                                iconLeft={ChatAltIcon as unknown as Icon}
                                onPress={(): void => {
                                    navigation.push('QueueSettings', {
                                        queue_id,
                                        tab: 'canned-messages',
                                    })
                                }}
                                text={t('Canned messages')}
                            />
                        </StyledDropdownButtonsWrapper>
                    </DropdownContent>
                </Dropdown>
            </li>
            <li>
                <Button color='text' data-tooltip-id='settings' iconLeft={CogIcon} onPress={(): void => { navigation.push('QueueSettings', {queue_id}) }} text='' />
                <Tooltip id='settings' position='right' singleLine>
                    {t('Settings')}
                </Tooltip>
            </li>
            <li>
                <Button
                    color='text'
                    data-tooltip-id='schedule'
                    iconLeft={HeroCalendarDaysIcon as unknown as Icon}
                    onPress={(): void => {
                        navigation.push('QueueSettings', {
                            queue_id,
                            tab: 'schedule',
                        })
                    }}
                    text=''
                />
                <Tooltip id='schedule' position='right' singleLine>
                    {t('Schedule')}
                </Tooltip>
            </li>
            <li>
                <Button
                    color='text'
                    data-tooltip-id='advenced'
                    iconLeft={HeroBeakerIcon as unknown as Icon}
                    onPress={(): void => {
                        navigation.push('QueueSettings', {
                            queue_id,
                            tab: 'advanced',
                        })
                    }}
                    text=''
                />
                <Tooltip id='advenced' position='right' singleLine>
                    {t('Advanced settings')}
                </Tooltip>
            </li>
            <li>
                <Button
                    color='text'
                    data-tooltip-id='canned-messages'
                    iconLeft={ChatAltIcon as unknown as Icon}
                    onPress={(): void => {
                        navigation.push('QueueSettings', {
                            queue_id,
                            tab: 'canned-messages',
                        })
                    }}
                    text=''
                />
                <Tooltip id='canned-messages' position='right' singleLine>
                    {t('Canned messages')}
                </Tooltip>
            </li>
        </StyledList>
    )
}
